<template>
    <body>
        
    </body>
    
</template>

<style>
    body {
        background-image: url("../assets/background.png");
        background-size: cover;
    }
</style>